/**
 * The landing page is its own scroller (`#app` is `overflow: hidden`), so
 * anything that measures scroll needs that element, not `window`. The page
 * provides it; sections inject it.
 */
import { inject, type InjectionKey, type Ref } from 'vue';

export const LANDING_SCROLLER: InjectionKey<Ref<HTMLElement | null>> = Symbol('landing-scroller');

export function useLandingScroller(): () => HTMLElement | null {
  const scroller = inject(LANDING_SCROLLER, null);
  return () => scroller?.value ?? null;
}
